import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { PropertyDataV2, ResponseData } from "../common"

interface PropertyRequestData {
  typeId: string | number
  customerId?: string | number
  googleAnalyticsId?: string | number
  hostname?: string | number
  jarvisClientId?: string | number
  jarvisPixelId?: string | number
  isgoogle?: boolean
  allInPricing?: boolean
}

export interface GetPropertiesFromConfigRequest
  extends Partial<AxiosRequestConfig> {
  params: PropertyRequestData
}

export interface GetPropertiesFromConfigResponseData extends ResponseData {
  data: PropertyDataV2[]
}

export interface GetPropertiesFromConfigResponse extends AxiosResponse {
  data: GetPropertiesFromConfigResponseData
}

export function getPropertiesFromConfigAPI(
  { params }: GetPropertiesFromConfigRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPropertiesFromConfigResponse> {
  return axiosInstance({
    params,
    method: "get",
    url: "/home/properties/by-type",
  }) as Promise<GetPropertiesFromConfigResponse>
}
